export const IS_JEST = process.env?.JEST_WORKER_ID !== undefined;
